import { Alert, Box, Button, FormControl, Grid, InputLabel, Link, MenuItem, Select, TextField } from "@mui/material";
import { Backend } from "../services/Backend";
import { useState } from "react";
import { DatePicker } from "@mui/x-date-pickers";

export function AdminAddUserPage() {
    const [error, setError] = useState("");
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [interest, setInterest] = useState("");
    const [language, setLanguage] = useState("");
    const [companyName, setCompanyName] = useState("");
    const [dateOfBirth, setDateOfBirth] = useState(null);
    const [functionTitle, setFunctionTitle] = useState("");
    const [address, setAddress] = useState("");
    const [state, setState] = useState("");
    const [country, setCountry] = useState("");
    const [zipcode, setZipcode] = useState("");
    const [isAdmin, setIsAdmin] = useState(false);

    const onRegister = () => {
        const body = {
            firstName,
            lastName,
            email,
            password,
            interest,
            language,
            companyName,
            dateOfBirth,
            function: functionTitle,
            address,
            state,
            country,
            zipcode,
            isAdmin,
        };

        for(var key in body) {
            if(body[key] === "" || body[key] === null) {
                setError("All fields is required");
                return;
            }
        }

        Backend.post("auth/register", body)
            .then(res => {
                window.location.href = '/dashboard/users';
            })
            .catch(err => setError(err));
    }

    return <>
        <div className="w-[400px] mx-[auto]">
            <h1 className="text-4xl text-center mb-[50px] font-semibold text-3x">Add new user</h1>

            {error && <Alert severity="error">{error}</Alert> }
            <Box component="form" sx={{ mt: 1 }}>
                <TextField margin="normal" required fullWidth label="First name" value={firstName} onChange={(e) => setFirstName(e.target.value)} /> 
                <TextField margin="normal" required fullWidth label="Last name" value={lastName} onChange={(e) => setLastName(e.target.value)} /> 
                <TextField margin="normal" required fullWidth label="Email Address" value={email} onChange={(e) => setEmail(e.target.value)} /> 
                <TextField margin="normal" required fullWidth label="Password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} /> 
                
                <FormControl fullWidth  margin="normal">
                    <InputLabel>Interest</InputLabel>
                    <Select
                        label="Interest"
                        margin="normal"
                        value={interest}
                        onChange={(e) => setInterest(e.target.value)}
                    >
                        <MenuItem value="Transport safety">Transport safety</MenuItem>
                        <MenuItem value="Industrial safety">Industrial safety</MenuItem>
                        <MenuItem value="Chemical warehousing">Chemical warehousing</MenuItem>
                        <MenuItem value="Tank storage">Tank storage</MenuItem>
                    </Select>
                </FormControl>
                <FormControl fullWidth margin="normal">
                    <InputLabel>Language</InputLabel>
                    <Select
                        label="Language"
                        margin="normal"
                        value={language}
                        onChange={(e) => setLanguage(e.target.value)}
                    >
                        <MenuItem value="English">English</MenuItem>
                        <MenuItem value="Dutch">Dutch</MenuItem>
                        <MenuItem value="German">German</MenuItem>
                        <MenuItem value="Spanish">Spanish</MenuItem>
                        <MenuItem value="French">French</MenuItem>
                        <MenuItem value="Chinese">Chinese</MenuItem>
                    </Select>
                </FormControl>

                <TextField margin="normal" required fullWidth label="Company name" className="mb-[20px]" value={companyName} onChange={(e) => setCompanyName(e.target.value)} /> 
                <DatePicker sx={{ mt: 2, mb: 1 }}  slotProps={{ textField: { fullWidth: true } }} margin="normal" required fullWidth label="Date of birth" value={dateOfBirth} onChange={(date) => setDateOfBirth(date)} /> 
                <TextField margin="normal" required fullWidth label="Function" value={functionTitle} onChange={(e) => setFunctionTitle(e.target.value)} /> 
                <TextField margin="normal" required fullWidth label="Address" value={address} onChange={(e) => setAddress(e.target.value)} /> 
                <TextField margin="normal" required fullWidth label="State" value={state} onChange={(e) => setState(e.target.value)} /> 
                <TextField margin="normal" required fullWidth label="Country" value={country} onChange={(e) => setCountry(e.target.value)} /> 
                <TextField margin="normal" required fullWidth label="Zip code" value={zipcode} onChange={(e) => setZipcode(e.target.value)} /> 
                <FormControl fullWidth margin="normal">
                    <Grid container alignItems="center">
                        <Grid item>
                            <input
                                type="checkbox"
                                checked={isAdmin}
                                onChange={(e) => setIsAdmin(e.target.checked)}
                                style={{ marginRight: '8px' }}
                            />
                        </Grid>
                        <Grid item>
                            Make user admin
                        </Grid>
                    </Grid>
                </FormControl>
                <Button
                    fullWidth
                    variant="contained"
                    sx={{ mt: 3, mb: 2 }}
                    onClick={onRegister}
                >
                Add new user
                </Button>
            </Box>
        </div>
    </>
}